import { APP_SETTINGS } from './constants';

function getEnv() {
  return window.location.hostname.includes('www.roland.com')
    ? 'production'
    : 'development';
}

export const appendAdobeAnalyticsScript = () => {
  if (!APP_SETTINGS.adobeAnalyticsEnabled) return;

  const script = document.createElement('script');
  script.src = window.location.hostname.includes('www.roland.com')
    ? 'https://assets.adobedtm.com/9b498e8f2e23/9a4431cd379c/launch-840302a8cdb1.min.js'
    : 'https://assets.adobedtm.com/9b498e8f2e23/9a4431cd379c/launch-bed61f5537d8-development.min.js';
  document.body.appendChild(script);
};

export const trackProductPageView = (userInfo) => {
  if (!APP_SETTINGS.adobeAnalyticsEnabled) return;

  const dlPage = {
    breadcrumbs: window.location.pathname,
    culture: userInfo?.cultureCode?.value || navigator.language || 'en-US',
    environment: getEnv(),
    pageName: document.title,
    pageTemplate: 'RC Memberships Page',
    platform: 'Roland Cloud - RCW',
    siteName: 'Roland Cloud',
  };

  const dl = { event: 'pageView', page: dlPage };

  if (!userInfo.guest && userInfo?.id) {
    dl.user = { rcpUserId: userInfo?.id || '' };
  }

  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(dl);
};
